import { Link } from 'react-router-dom';
import { IconCamera } from './Icon';

/** The camera is the primary action, reachable from every page in one tap. */
export default function CameraFab() {
  return (
    <Link className="fab" to="/upload" aria-label="Add photos">
      <IconCamera size={27} />
    </Link>
  );
}
